/* This is generated code, don't alter */
var IfcEvaporatorTypeEnum;
(function (IfcEvaporatorTypeEnum) {
    IfcEvaporatorTypeEnum[IfcEvaporatorTypeEnum["DIRECTEXPANSION"] = 0] = "DIRECTEXPANSION";
    IfcEvaporatorTypeEnum[IfcEvaporatorTypeEnum["DIRECTEXPANSIONSHELLANDTUBE"] = 1] = "DIRECTEXPANSIONSHELLANDTUBE";
    IfcEvaporatorTypeEnum[IfcEvaporatorTypeEnum["DIRECTEXPANSIONTUBEINTUBE"] = 2] = "DIRECTEXPANSIONTUBEINTUBE";
    IfcEvaporatorTypeEnum[IfcEvaporatorTypeEnum["DIRECTEXPANSIONBRAZEDPLATE"] = 3] = "DIRECTEXPANSIONBRAZEDPLATE";
    IfcEvaporatorTypeEnum[IfcEvaporatorTypeEnum["FLOODEDSHELLANDTUBE"] = 4] = "FLOODEDSHELLANDTUBE";
    IfcEvaporatorTypeEnum[IfcEvaporatorTypeEnum["SHELLANDCOIL"] = 5] = "SHELLANDCOIL";
    IfcEvaporatorTypeEnum[IfcEvaporatorTypeEnum["USERDEFINED"] = 6] = "USERDEFINED";
    IfcEvaporatorTypeEnum[IfcEvaporatorTypeEnum["NOTDEFINED"] = 7] = "NOTDEFINED";
})(IfcEvaporatorTypeEnum || (IfcEvaporatorTypeEnum = {}));
const IfcEvaporatorTypeEnumCount = 8;
export { IfcEvaporatorTypeEnum, IfcEvaporatorTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcEvaporatorTypeEnum = new Int32Array([7, 0, 84]);
let prefixSumAddressIfcEvaporatorTypeEnum = new Uint32Array([0, 12, 41, 62, 89, 106, 120, 148, 161]);
let slotMapIfcEvaporatorTypeEnum = new Int32Array([7, 1, 4, 2, 0, 5, 3, 6]);
let encodedDataIfcEvaporatorTypeEnum = (new TextEncoder()).encode(".NOTDEFINED..DIRECTEXPANSIONSHELLANDTUBE..FLOODEDSHELLANDTUBE..DIRECTEXPANSIONTUBEINTUBE..DIRECTEXPANSION..SHELLANDCOIL..DIRECTEXPANSIONBRAZEDPLATE..USERDEFINED.");
let IfcEvaporatorTypeEnumSearch = new MinimalPerfectHash(gMapIfcEvaporatorTypeEnum, prefixSumAddressIfcEvaporatorTypeEnum, slotMapIfcEvaporatorTypeEnum, encodedDataIfcEvaporatorTypeEnum);
export { IfcEvaporatorTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcEvaporatorTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcEvaporatorTypeEnumSearch, input, cursor, endCursor);
}
